import logInfo from '../../utils/logInfo';
import adCenterApiService from '../adCenterApiService';
import configurationService from '../configurationService';

class CurrentUserService {
  async fetchHasAccessToExportToCsv(seekAdvertiserId: string) {
    try {
      const result: {
        hasAccess: boolean;
      } = await adCenterApiService.get(
        configurationService.getRelativeUrl(
          `/api/v2/betaprogram/${seekAdvertiserId}/ExportToCsv/hasaccess`,
        ),
      );

      return result;
    } catch (error: any) {
      logInfo(error);
      return Promise.reject(error);
    }
  }
}

export default new CurrentUserService();
